import { useMutation } from "react-query";
import { updateFamilyMentalHealthHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

export const useUpdateFamilyMentalHealthHistory = (options: Record<string, any> = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ id, payload }: { id: number; payload: Record<string, any> }) =>
      updateFamilyMentalHealthHistory(id, payload),
    {
      onError: () => {
        showToast({
          message: "Whoops! Something went wrong while updating the family mental health history.",
          errorState: true,
        });
        onError();
      },
      ...otherOptions,
    }
  );

  return {
    updateFamilyMentalHealthHistoryMutation: mutate,
    isUpdateFamilyMentalHealthHistoryLoading: isLoading,
    ...rest,
  };
};

export default useUpdateFamilyMentalHealthHistory;
